<template>
    <v-container fluid class="pt-12">
        <v-row v-if="task">
            <v-col cols="2">
                <v-progress-circular size="64" color="primary" indeterminate v-if="!isFinished && !progress"></v-progress-circular>
                <v-progress-circular size="64" color="primary" :value="progress" v-else-if="!isFinished"></v-progress-circular>
            </v-col>
            <v-col>
                <h2 class="page-title page-title__primary mb-2">{{title}}</h2>
                <p v-if="statusText && !isFinished">{{statusText}}</p>
                <p v-if="hasSteps">Шаг {{innerTask && innerTask.step_number || 0}}</p>
                <p v-if="innerTask && innerTask.inflation_factor_history && innerTask.inflation_factor_history.length && !isFinished">
                    <span>Осталось примерно: {{timeLeft || 'Неизвестно'}}</span>
                </p>
                <v-alert type="error" v-if="hasError">{{innerTask && innerTask.error || 'Неизвестная ошибка'}}</v-alert>
                <v-expansion-panels accordion multiple>
                    <v-expansion-panel>
                        <v-expansion-panel-header>
                            Инфляционный фактор: {{innerTask && innerTask.inflation_factor || 'Неизвестно'}}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <p v-if="innerTask && innerTask.inflation_factor_history && innerTask.inflation_factor_history.length">
                                <!--plotly :data="historyPlotData" :layout="plotLayout" :static-plot="true"></plotly-->
                                <plotly :data="historyPlotData" :layout="plotLayout" :static-plot="true"></plotly>
                            </p>                            
                            <span v-else class="text-muted">Ожидание данных...</span>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Полный лог</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <pre class="log" ref="log" v-if="shownLog">{{ shownLog }}</pre>
                            <span v-else class="text-muted">Ожидание данных...</span>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <v-btn color="primary" class="mt-4" v-if="isFinished && isPredict"
                    @click="gotoResult"
                >Посмотреть результаты</v-btn>
                <v-btn color="primary" class="mt-4" v-else-if="isFinished"
                    @click="gotoNewPredict"
                >Запустить расчет</v-btn>
                <v-btn color="primary" class="mt-4" v-else
                    @click="gotoList"
                >К списку задач</v-btn>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col>
                Расчетная задача пока не создана. Перейдите в раздел "Настройки"
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { Plotly } from 'vue-plotly';
export default {
    props: ['task', 'visible'],
    components: { Plotly },
    data() {
        return {
            progressPollIntervalId: null,
            pollIntervalMs: 10000,
            innerTask: this.task,
            shownLog: null,
            statuses: {
                'input': 'В очереди',
                'init': 'Запуск',
                'adapt': 'Адаптация',
                'optimize': 'Оптимизация',
                'results': 'Сохранение результатов',
                'predict': 'Прогноз',
                'finished': 'Расчет завершен',
                'error': 'Ошибка'
            }
        }
    },
    created() {
        if (!this.isFinished) {
            this.startPoll();
        }
    },
    watch: {
        task: {
            deep: true,
            handler() {
                this.innerTask = this.task;
                this.startPoll();
            }
        },
        isFinished() {
            if (this.isFinished) {
                this.stopPoll();
            }
            else {
                if (this.visible) {
                    this.startPoll();
                }
            }
        },
        visible() {
            if (this.visible) {
                this.startPoll();
            }
            else {
                this.stopPoll();
            }
        },
        innerLog() {
            if (this.innerLog) {
                this.shownLog = this.innerLog.split('\n').reverse().join('\n').trim();
            }
        }
    },
    methods: {
        startPoll() {
            if (this.progressPollIntervalId) {
                this.stopPoll();
            }

            if (this.task && this.task.problemId) {
                this.progressPollIntervalId = setInterval(async () => {
                    let updatedTasks = await this.$store.dispatch('task/loadItems', {problemId: this.task.problemId});
                    this.innerTask = updatedTasks.find(task => task.id === this.innerTask.id);

                    await this.$store.dispatch('task/setOptimizeItem', this.task.problemId);
                    await this.$store.dispatch('task/setPredictItem', this.task.problemId);
                    await this.$store.dispatch('task/setWellsItem', this.task.problemId);
                }, this.pollIntervalMs);
            }
        },
        stopPoll() {
            if (this.progressPollIntervalId) {
                clearInterval(this.progressPollIntervalId);
                this.progressPollIntervalId = null;
            }
        },
        async gotoResult() {
            return this.$router.push({name: 'viewResult', params: {id: this.innerTask.id}});
        },
        async gotoNewPredict() {
            return this.$router.push({
                name: 'taskNew',
                params: {id: this.innerTask.problemId},
                query: {type: 'predict', adaptId: this.innerTask.id},
            });
        },
        async gotoList() {
            return this.$router.push({name: 'viewResult', params: {id: this.innerTask.id}});
        },
    },
    beforeDestroy() {
        this.stopPoll();
    },
    computed: {
        progress() {
            return this.innerTask && this.innerTask.progress > 0 
                ? this.innerTask.progress 
                : null;
        },
        progressText() {
            return this.innerTask && this.innerTask.progress > 0 ? parseFloat(this.innerTask.progress).toFixed(1)+'%' : '0%';
        },
        status() {
            return this.innerTask ? this.innerTask.status || 'Инициализация' : 'Инициализация';
        },
        statusText() {
            return this.innerTask ? this.statuses[this.innerTask.status] || 'Ожидание' : 'Загрузка';
        },
        title() {
            if (this.isFinished) {
                if (this.isPredict) {
                    return 'Расчет закончен';
                }
                else {
                    return 'Адаптация завершена';
                }
            }
            else {
                if (this.isPredict) {
                    return 'Идет расчет прогноза';
                }
                else {
                    return 'Идет адаптация модели';
                }
            }
        },
        isFinished() {
            return this.innerTask && this.innerTask.status && this.innerTask.status === 'finished';
        },
        hasError() {
            return this.innerTask?.status === 'error';
        },
        taskType() {
            return this.innerTask?.type || null;
        },
        isPredict() {
            return this.taskType === 'predict';
        },
        hasSteps() {
            return this.taskType !== 'adapt';
        },
        historyPlotData() {
            if (!this.innerTask || !this.innerTask.inflation_factor_history) {
                return [];
            }

            let startTime = this.innerTask.inflation_factor_history[0].time;
            let x = this.innerTask.inflation_factor_history.map(point => (new Date(point.time) - new Date(startTime)) / 1000 / 60);
            let y = this.innerTask.inflation_factor_history.map(point => point.value);

            let plot = {
                x,
                y,
                type: 'scatter',
                name: 'Инфляционный фактор'
            };

            return [plot];
        },
        plotLayout() {
            let maxTime = this.innerTask.inflation_factor_history.length ?
                (new Date(this.innerTask.inflation_factor_history[this.innerTask.inflation_factor_history.length - 1].time) - new Date(this.innerTask.inflation_factor_history[0].time)) / 1000 / 60
                : 1;
            if (maxTime < 10) {
                maxTime = 10;
            }

            return {
                margin: {
                    l: 70,
                    r: 10,
                    b: 50,
                    t: 10,
                },
                xaxis: {
                    title: 'Время, мин',
                    range: [0, maxTime],
                },
                yaxis: {
                    type: 'log',
                },
            };
        },
        timeLeft() {
            if (this.isFinished || !this.innerTask || !this.innerTask.inflation_factor_history) {
                return null;
            }

            if (this.innerTask.inflation_factor_history.length < 2) {
                return null;
            }

            let lastPoint = this.innerTask.inflation_factor_history[this.innerTask.inflation_factor_history.length - 1];
            let prevPoint = this.innerTask.inflation_factor_history[this.innerTask.inflation_factor_history.length - 2];
            let factorChange = Math.abs(Math.log(lastPoint.value) - Math.log(prevPoint.value));
            let timeChange = (new Date(lastPoint.time) - new Date(prevPoint.time));

            if (factorChange < 1e-6) {
                return null;
            }

            let remainingFactorChange = Math.abs(Math.log(lastPoint.value));
            let estimatedMsLeft = remainingFactorChange / factorChange * timeChange;
            let seconds = Math.floor(estimatedMsLeft / 1000);
            if (seconds < 0) {
                return null;
            }

            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);
            let days = Math.floor(hours / 24);

            seconds = seconds % 60;
            minutes = minutes % 60;
            hours = hours % 24;

            let parts = [];
            if (days > 0) {
                parts.push(days + ' д');
            }
            if (hours > 0) {
                parts.push(hours + ' ч');
            }
            if (minutes > 0) {
                parts.push(minutes + ' м');
            }
            if (seconds > 0 && parts.length < 2) {
                parts.push(seconds + ' с');
            }

            return parts.join(' ');
        },
        innerLog() {
            return this.innerTask ? this.innerTask.log || '' : '';
        }
    }
}
</script>

<style scoped>
    .log {
        max-height: 500px;
        overflow: auto;
    }
</style>
